import { EXTENSION } from '@/constants';
import { sendMessage } from '@/services/messageBus';
import { getBrowserName, getBrowserKey } from '@/services/browser';
import { parseFullName } from '@/services/user';

export function install() {
  window.open(EXTENSION[getBrowserKey()], 'blank');
}

export const getExtensionVersion = async () => {
  try {
    const version = await sendMessage.async({ message: 'version' });
    return version;
  } catch {
    return null;
  }
};

export const isExtensionInstalled = async () => {
  try {
    return !!(await getExtensionVersion());
  } catch {
    return false;
  }
};

export const startSession = async (user) =>
  sendMessage({
    message: 'session/start',
    data: {
      accessToken: await user.getIdToken(),
      refreshToken: user.refreshToken,
      user: {
        uid: user.uid,
        email: user.email,
        emailVerified: user.emailVerified,
        displayName: user.displayName,
        ...parseFullName(user.displayName),
      },
    },
  });

export const stopSession = () => sendMessage({ message: 'session/finish' });

export const getExtensionDetails = async () => {
  const extensionVersion = await getExtensionVersion();

  if (!extensionVersion) {
    return {
      installed: false,
    };
  }

  return {
    installed: true,
    version: extensionVersion,
    type: getBrowserName(),
  };
};
